import React, { Suspense, useEffect, useLayoutEffect, useRef } from 'react';
//import "../../scss/templates.scss";
import PageLoader from '../common/PageLoader';
import { handleResizing } from '../../helper';
import { render } from "react-dom";
import DUMMY_RESUME from '../../constants/defaultData';

import { ADDITONAL_PREDEFINE_SECTIONS, DEFAULT_SECTION_DISPLAY_ORDER, TEMPLATES_IN_V2 } from '../../constants/constants';


// import TemplateOne from "./TemplateOne/Templates";
// import TemplateTwo from "./TemplateTwo/Templates";
// import TemplateThree from "./TemplateThree/Templates";
// import TemplateFour from "./TemplateFour/Templates";
// import TemplateFive from "./TemplateFive/Templates";
// import TemplateSix from "./TemplateSix/Templates";
// import TemplateSeven from "./TemplateSeven/Templates";
// import TemplateEight from "./TemplateEight/Templates";
// import TemplateNine from "./TemplateNine/Templates";
let TPL = {}
 TPL['template-ten-v3'] = React.lazy(() => import("./TemplateTen/Template10V3"));
 TPL['template-eight-v2'] = React.lazy(() => import("./TemplateEight/Template8V2"));
 TPL['template-four-v2'] = React.lazy(() => import("./TemplateFour/Template4V2"));
 TPL['template-three-v5'] = React.lazy(() => import("./TemplateThree/Template3V5"));
 TPL['template-six-v2'] = React.lazy(() => import("./TemplateSix/Template6V2"));
 TPL['template-ten'] = React.lazy(() => import("./TemplateTen/Template10V1"));
 TPL['template-nine-v2'] = React.lazy(() => import("./TemplateNine/Template9V2"));
 TPL['template-ten-v4'] = React.lazy(() => import("./TemplateTen/Template10V4"));

// TPL['template-one'] = React.lazy(() => import("./TemplateOne/Template1V1"));
// TPL['template-one-v2'] = React.lazy(() => import("./TemplateOne/Template1V2"));
// TPL['template-one-v3'] = React.lazy(() => import("./TemplateOne/Template1V3"));

// TPL['template-two'] = React.lazy(() => import("./TemplateTwo/Template2V1"));
// TPL['template-two-v2'] = React.lazy(() => import("./TemplateTwo/Template2V2"));
// TPL['template-two-v3'] = React.lazy(() => import("./TemplateTwo/Template2V3"));

// TPL['template-three'] = React.lazy(() => import("./TemplateThree/Template3V1"));
// TPL['template-three-v2'] = React.lazy(() => import("./TemplateThree/Template3V2"));
// TPL['template-three-v3'] = React.lazy(() => import("./TemplateThree/Template3V3"));
// TPL['template-three-v4'] = React.lazy(() => import("./TemplateThree/Template3V4"));
// TPL['template-three-v5'] = React.lazy(() => import("./TemplateThree/Template3V5"));

// TPL['template-four'] = React.lazy(() => import("./TemplateFour/Template4V1"));
// TPL['template-four-v2'] = React.lazy(() => import("./TemplateFour/Template4V2"));
// TPL['template-four-v3'] = React.lazy(() => import("./TemplateFour/Template4V3"));
// TPL['template-four-v4'] = React.lazy(() => import("./TemplateFour/Template4V4"));
// TPL['template-four-v5'] = React.lazy(() => import("./TemplateFour/Template4V5"));

// TPL['template-five'] = React.lazy(() => import("./TemplateFive/Template5V1"));
// TPL['template-five-v2'] = React.lazy(() => import("./TemplateFive/Template5V2"));
// TPL['template-five-v3'] = React.lazy(() => import("./TemplateFive/Template5V3"));
// TPL['template-five-v4'] = React.lazy(() => import("./TemplateFive/Template5V4"));
// TPL['template-five-v5'] = React.lazy(() => import("./TemplateFive/Template5V5"));

// TPL['template-six'] = React.lazy(() => import("./TemplateSix/Template6V1"));
// TPL['template-six-v2'] = React.lazy(() => import("./TemplateSix/Template6V2"));
// TPL['template-six-v3'] = React.lazy(() => import("./TemplateSix/Template6V3"));

// TPL['template-seven'] = React.lazy(() => import("./TemplateSeven/Template7V1"));
// TPL['template-seven-v2'] = React.lazy(() => import("./TemplateSeven/Template7V2"));
// TPL['template-seven-v3'] = React.lazy(() => import("./TemplateSeven/Template7V3"));

// TPL['template-eight'] = React.lazy(() => import("./TemplateEight/Template8V1"));
// TPL['template-eight-v2'] = React.lazy(() => import("./TemplateEight/Template8V2"));
// TPL['template-eight-v3'] = React.lazy(() => import("./TemplateEight/Template8V3"));

// TPL['template-nine'] = React.lazy(() => import("./TemplateNine/Template9V1"));
// TPL['template-nine-v2'] = React.lazy(() => import("./TemplateNine/Template9V2"));
// TPL['template-nine-v3'] = React.lazy(() => import("./TemplateNine/Template9V3"));

// TPL['template-ten'] = React.lazy(() => import("./TemplateTen/Template10V1"));
// TPL['template-ten-v2'] = React.lazy(() => import("./TemplateTen/Template10V2"));
// TPL['template-ten-v3'] = React.lazy(() => import("./TemplateTen/Template10V3"));
// TPL['template-ten-v4'] = React.lazy(() => import("./TemplateTen/Template10V4"));
// TPL['template-ten-v5'] = React.lazy(() => import("./TemplateTen/Template10V5"));

// TPL['template-eleven'] = React.lazy(() => import("./TemplateEleven/Template11"));

// TPL['template-twelve'] = React.lazy(() => import("./TemplateTwelve/Template12"));

// TPL['template-thirteen'] = React.lazy(() => import("./TemplateThirteen/Template13"));

// TPL['template-fourteen'] = React.lazy(() => import("./TemplateFourteen/Template14"));

// TPL['template-fifteen'] = React.lazy(() => import("./TemplateFifteen/Template15"));

// TPL['template-sixteen'] = React.lazy(() => import("./TemplateSixteen/Template16"));

// TPL['template-seventeen'] = React.lazy(() => import("./TemplateSeventeen/Template17"));

// TPL['template-eighteen'] = React.lazy(() => import("./TemplateEighteen/Template18"));

// TPL['template-nineteen'] = React.lazy(() => import("./TemplateNineteen/Template19"));

// TPL['template-twenty'] = React.lazy(() => import("./TemplateTwenty/Template20"));

// TPL['template-twenty-one'] = React.lazy(() => import("./TemplateTwentyOne/Template21"));

// TPL['template-twenty-five'] = React.lazy(() => import("./TemplateTwentyFive/Template25"));

// TPL['template-twenty-three'] = React.lazy(() => import("./TemplateTwentyThree/Template23"));

// TPL['template-twenty-four'] = React.lazy(() => import("./TemplateTwentyFour/Template24"));

// TPL['template-thirty-one'] = React.lazy(() => import("./TemplateThirtyOne/Template31"));
// TPL['template-thirty-two'] = React.lazy(() => import("./TemplateThirtyTwo/Template32"));
// TPL['template-thirty-three'] = React.lazy(() => import("./TemplateThirtyThree/Template33"));
// TPL['template-thirty-four'] = React.lazy(() => import("./TemplateThirtyFour/Template34"));
// TPL['template-thirty-five'] = React.lazy(() => import("./TemplateThirtyFive/Template35"));
// TPL['template-thirty-six'] = React.lazy(() => import("./TemplateThirtySix/Template36"));
// TPL['template-thirty-seven'] = React.lazy(() => import("./TemplateThirtySeven/Template37"));
// TPL['template-thirty-eight'] = React.lazy(() => import("./TemplateThirtyEight/Template38"));
// TPL['template-thirty-nine'] = React.lazy(() => import("./TemplateThirtyNine/Template39"));
// TPL['template-forty'] = React.lazy(() => import("./TemplateForty/Template40"));
// TPL['template-forty-one'] = React.lazy(() => import("./TemplateFortyOne/Template41"));
// TPL['template-forty-two'] = React.lazy(() => import("./TemplateFortyTwo/Template42"));
// TPL['template-forty-three'] = React.lazy(() => import("./TemplateFortyThree/Template43"));
// TPL['template-forty-four'] = React.lazy(() => import("./TemplateFortyFour/Template44"));
// TPL['template-forty-five'] = React.lazy(() => import("./TemplateFortyFive/Template45"));
// TPL['template-forty-six'] = React.lazy(() => import("./TemplateFortySix/Template46"));
// TPL['template-forty-seven'] = React.lazy(() => import("./TemplateFortySeven/Template47"));
// TPL['template-forty-eight'] = React.lazy(() => import("./TemplateFortyEight/Template48"));
// TPL['template-forty-nine'] = React.lazy(() => import("./TemplateFortyNine/Template49"));
// TPL['template-fifty'] = React.lazy(() => import("./TemplateFifty/Template50"));

// TPL['template-docx'] = React.lazy(() => import("./TemplateDocx/Template1V1"));

// let DR = {};
const Resumes = (props) => {
  // const [currentResumeData, setCurrentResumeData] = React.useState({});
  const scale = props.hasOwnProperty('scale') ? props.scale : '';
  const selected_template = (props.hasOwnProperty('fileType') && props.fileType == 'docx') ? 'template-docx' : props.data.active_template;
  //const selected_template = 'template-docx';
  let _t = props.data;
  let DR = DUMMY_RESUME;
  // DR = currentResumeData;
  // const updateDR = async( ) => {
  //   const templateDefaultData = await import(`../../constants/templateDefaultData/${selected_template}.jsx`);
  //   try {
  //     DR = templateDefaultData?.default;
  //     setCurrentResumeData(DR);
  //   } catch (error) {
  //     DR = DUMMY_RESUME;
  //     setCurrentResumeData(DR);
  //     console.log(error)
  //   }
  // }
  // if(TEMPLATES_IN_V2.includes(selected_template)) {
  //   updateDR();
  // } else {
  //   DR = DUMMY_RESUME;
  // }
  if(!Object.keys(DR).length) return false
  //backward compatibility for social links structure changed to portfolio. it will not break the dashboard page for such resumes
  if(!_t.hasOwnProperty('portfolio') && _t.hasOwnProperty('socials')){
    _t = {..._t, portfolio:{ set:{}}}
    Object.keys(_t.socials).map(k =>{
      let id = 'id_' + Math.floor(Math.random() * 1000);
      //Only add available options
      let ob = { [id]: { label:  _t.socials[k].name, link: _t.socials[k].link } }
      _t.portfolio.set = {..._t.portfolio.set, ...ob}
      })
  }
  const resume = _t
  // const find_last_hyphen = /-v\d+$/;
  // const final_selected_template = selected_template ? selected_template.replace(find_last_hyphen, '') : 'template-one';
  const mergeDummy = () => {
    let rm = JSON.parse(JSON.stringify({ ...resume })), src, dest
    //Replace all heading fields in case of empty field

    if(!(rm.summary.content.length || rm.heading.city.length)) (rm.summary.content = DR.summary.content)

    Object.keys(rm.heading).map((k) => {
      //Dont add default for state, zip if city added
      (
        (!resume.heading.fname?.length) ||
        (resume.heading.fname.length &&
          !['profession'].includes(k)
        )
      ) && (
        (!resume.heading.address?.length) ||
        (resume.heading.address.length &&
          !['city','state', 'zipcode','address','phone'].includes(k)
        )
      ) && (
        (!resume.heading.city?.length) ||
        (resume.heading.city.length &&
          !['state', 'zipcode','address','phone'].includes(k)
        )
      ) &&
        !rm.heading[k].length &&
        DR.heading.hasOwnProperty(k) &&
        (rm.heading[k] = DR.heading[k])
    })
    dest = rm.work_history.jobs
    src = DR.work_history.jobs
    //Show dummy data for first time, finally remove all as user start adding description
    if (dest.hasOwnProperty('job_1') && Object.keys(dest).length == 1 && !dest.job_1.job.description.length) {
      !dest.job_1.job.job_title.length && (dest.job_1.job.job_title = src.job_1.job.job_title)
      if(!dest.job_1.job.employer.length){//Stop showing dummy content, after employer addition
        !dest.job_1.job.start_date.length && (dest.job_1.job.currently_working = true)
        dest.job_1.job.employer = src.job_1.job.employer
        !dest.job_1.job.city.length && (dest.job_1.job.city = src.job_1.job.city)
        !dest.job_1.job.state.length && (dest.job_1.job.state = src.job_1.job.state)
        !dest.job_1.job.start_date.length && (dest.job_1.job.start_date = src.job_1.job.start_date)
        !dest.job_1.job.end_date.length && (dest.job_1.job.end_date = src.job_1.job.end_date)
      }
      if(!dest.job_1.job.description.length) dest.job_1.job.description = src.job_1.job.description
      // Object.keys(dest.job_1.job).map((k) => {
      //   (typeof dest.job_1.job[k] == 'string') && !dest.job_1.job['job_title'].length && src.job_1.job.hasOwnProperty(k) && (dest.job_1.job[k] = src.job_1.job[k])
      // })
      //Only sync till state date is not added
      
      dest.job_2 = src.job_2
    }
    let dest1 = rm.education_history.all
    let src1 = DR.education_history.all
    //Show dummy data for first time, finally remove all as user add dummy data
    if (dest1.hasOwnProperty('education_1') && Object.keys(dest1).length == 1 && !dest1.education_1.education.school_name.length) {
      // if(!dest1.education_1.education.school_name.length){//Stop showing dummy content, after employer addition
      dest1.education_1.education.school_name = src1.education_1.education.school_name;
      !dest1.education_1.education.school_location.length && (dest1.education_1.education.school_location = src1.education_1.education.school_location);
      (!dest1.education_1.education.degree.length || dest1.education_1.education.degree == 'select') && (dest1.education_1.education.degree = src1.education_1.education.degree);
        !dest1.education_1.education.field_of_study.length && (dest1.education_1.education.field_of_study = src1.education_1.education.field_of_study)
        !dest1.education_1.education.start_date.length && (dest1.education_1.education.start_date = src1.education_1.education.start_date)
        !dest1.education_1.education.end_date.length && (dest1.education_1.education.end_date = src1.education_1.education.end_date)
        !dest1.education_1.education.description.length && (dest1.education_1.education.description = src1.education_1.education.description)
      // }
      // Object.keys(dest1.education_1.education).map((k) => {
      //   (typeof dest1.education_1.education[k] == 'string') && !dest1.education_1.education[k].length && src1.education_1.education.hasOwnProperty(k) && (dest1.education_1.education[k] = src1.education_1.education[k])
      // })
      // if (dest1.education_1.education.degree == 'select') dest1.education_1.education.degree = src1.education_1.education.degree
    }
  
    let dest2 = rm.skills.set
    let src2 = DR.skills.set
    if (dest2.hasOwnProperty('skill_1') && Object.keys(dest2).length == 1 && !dest2.skill_1.name.length) {
      rm.skills.set = src2
    }
    return rm
  }
  const displayOrder = () => {
    let section_list =[];
    if(resume.hasOwnProperty('sections_display_order') && resume.sections_display_order.length){
      //In case any core sectons are missed and also not skipped. This might happen
      section_list = resume.sections_display_order
      const missing = DEFAULT_SECTION_DISPLAY_ORDER.filter(name => 
        (resume.sections_display_order.indexOf(name) == -1 && 
        resume.skipped_sections.indexOf(name) == -1 ))
        section_list = section_list.concat(missing)
    }else section_list = DEFAULT_SECTION_DISPLAY_ORDER;
    
    //Check all addtional sections and if not list
    Object.keys(ADDITONAL_PREDEFINE_SECTIONS).map(v => {
      if(section_list.indexOf(v) == - 1 && resume.hasOwnProperty(v)) section_list = section_list.concat(v)
    })
    //Check all custom sections in list and if not list
    resume.additional_sections.custom.map(v => {
      if(section_list.indexOf(v) == - 1) section_list = section_list.concat(v)
    })
    return section_list
  }

  const getTemplate = () => {
    const TplName = TPL[selected_template] ?? 'template-ten-v3';
    return (<TplName data={props.hasOwnProperty('no_dummy') ? resume : mergeDummy()} abspath={props.hasOwnProperty('abspath') ? props.abspath : false} getDisplayOrder={displayOrder} scale={scale} />);
  }


  return (
    <div className={`resume-container no-print-border`}>
      {props.hasOwnProperty('nolazy') ? getTemplate() : <Suspense fallback={<PageLoader />}>{getTemplate()}</Suspense>}
    </div>
  );
}

export default Resumes;